import { render, staticRenderFns } from "./SpecAutocompleteSingle.vue?vue&type=template&id=36ad0502"
import script from "./SpecAutocompleteSingle.vue?vue&type=script&lang=js"
export * from "./SpecAutocompleteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports